
<div style="display: flex;justify-content: center;" >
  <mat-card style="width: max-content">
    <mat-card-header
      style="justify-content: center; background-color: ghostwhite"
    >
      <mat-card-title>
        <span>
          <img
            alt="Logo"
            src="assets/images/TLS_Logo.png"
            style="height: 32px; margin-top: 9px; float: center"
          />
        </span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="margin-top: 3%; margin-bottom: 1%">
      <div>
        <div *ngIf="errorMessage" style="display: flex;
        justify-content: center;
        margin: 3%;">
          {{ errorMessage }}
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)">
          <mat-form-field
            appearance="outline"
            style="width: 500px; margin-bottom: 10px"
          >
            <input matInput formControlName="username" placeholder="username" />
            <mat-icon matPrefix style="border-right: groove; margin-right: 20px;margin-left: 10px;"
              >person</mat-icon
            >
            <mat-error *ngIf="loginForm.controls.username.errors?.required">
              Required
            </mat-error> </mat-form-field
          ><br />

          <div style="display: flex; justify-content: center">
            <button
              type="submit"
              mat-raised-button
              style="background-color: steelblue; color: white"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <hr>

    </mat-card-content>
  </mat-card>
  </div>

